import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { warehousesListingSearchParamsSchema } from './schemas';
import { menuLayoutRoute } from '../../root/MenuLayout';

const warehousesMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: 'warehouses',
});

const warehousesListingRoute = createRoute({
  getParentRoute: () => warehousesMainRoute,
  path: '/',
  validateSearch: warehousesListingSearchParamsSchema,
  component: lazyRouteComponent(() => import('features/warehouses/WarehousesView/WarehousesView')),
});

export const warehousesRouteTree = warehousesMainRoute.addChildren({
  warehousesListingRoute,
});
